let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1TOYq"), load("8DoxJ"), load("ffEVr"), load("joJy8"), load("aHE9G"), load("7pZ0V"), load("bCr24")]).then(() => parcelRequire('arPKr'));